enum SignInEnum {
	SIGN_IN = '/',
	LOGIN = '/login',
}

enum AuthorizationB2BEnum {
	AUTHORIZATION = '/autorizacao',
}

enum ForgotPasswordEnum {
	FORGOT_PASSWORD = 'esqueci-minha-senha',
}

enum SignUpEnum {
	SIGN_UP = 'cadastro',
	SIGN_UP_UPDATE = 'cadastro/atualizacao',
}

enum FirstAccessEnum {
	FIRST_ACCESS = 'primeiro-acesso',
}

enum SelectionFlowEnum {
	PLAN_SELECTION = '/plano',
	BENEFICIARY_SELECTION = '/plano/beneficiarios',
	CONFIRM_SELECTION = '/plano/confirmacao',
}

enum HomeEnum {
	HOME_PAGE = '/inicio',
	EARLY_ACCESS = '/inicio/acesso-antecipado',
	ACCESS_PORTAL = '/inicio/acessar-portal',
}

enum MyPaymentsEnum {
	BILLET_DETAILS = '/servicos/meu-financeiro/detalhes-do-boleto',
	PAYMENTS_HISTORY = '/servicos/meu-financeiro/historico-de-pagamentos',
	COPARTICIPATION = '/servicos/meu-financeiro/extrato-de-coparticipacao',
	INCOME_TAX = '/servicos/meu-financeiro/imposto-de-renda',
	OPEN_BILLS = '/servicos/meu-financeiro',
}

enum MyAppointmentsEnum {
	MY_APPOINTMENTS = '/servicos/meus-agendamentos',
	MY_APPOINTMENTS_DETAILS_HEALTH = '/servicos/meus-agendamentos/detalhes-do-agendamento/consulta/:id',
	MY_APPOINTMENTS_DETAILS_TELEHEALTH = '/servicos/meus-agendamentos/detalhes-do-agendamento/teleconsulta/:id',
	MY_APPOINTMENTS_DETAILS_ODONTO = '/servicos/meus-agendamentos/detalhes-do-agendamento/dentista/:id',
	MY_APPOINTMENTS_DETAILS_EXAM = '/servicos/meus-agendamentos/detalhes-do-agendamento/exame/:id',
	MY_APPOINTMENTS_DETAILS_SURGERY = '/servicos/meus-agendamentos/detalhes-do-agendamento/cirurgia/:id',
	MY_APPOINTMENTS_HISTORY = '/servicos/meus-agendamentos/historico-de-agendamento',
	MY_APPOINTMENTS_HISTORY_DETAILS = '/servicos/meus-agendamentos/historico-de-agendamento/detalhes-da-consulta/:id',
	MY_APPOINTMENTS_HISTORY_SURGERY_DETAILS = '/servicos/meus-agendamentos/historico-de-agendamento/detalhes-da-cirurgia/:id',
}

enum ExamResultsEnum {
	EXAM_RESULTS = '/servicos/resultado-de-exames',
	EXAM_RESULTS_DETAILS = '/servicos/resultado-de-exames/:id',
	EXAM_RESULTS_WAITING = '/servicos/resultado-de-exames/aguardando-liberacao',
}

enum GuidesEnum {
	HEALTH_GUIDE = '/servicos/guia-medico',
	ODONTO_GUIDE = '/servicos/guia-odonto',
	SERVICE_NETWORK_HEALTH = '/servicos/rede-de-atendimento',
	SERVICE_NETWORK_ODONTO = '/servicos/rede-de-atendimento-odonto',
	SERVICE_NETWORK_HEALTH_FLOW_UF = '/servicos/rede-de-atendimento/inicio/estado',
	SERVICE_NETWORK_HEALTH_FLOW_CITY = '/servicos/rede-de-atendimento/inicio/cidade',
	SERVICE_NETWORK_HEALTH_FLOW_DISTRICT = '/servicos/rede-de-atendimento/inicio/bairros',
	SERVICE_NETWORK_ODONTO_FLOW_UF = '/servicos/rede-de-atendimento-odonto/inicio/estado',
	SERVICE_NETWORK_ODONTO_FLOW_CITY = '/servicos/rede-de-atendimento-odonto/inicio/cidade',
	SERVICE_NETWORK_ODONTO_FLOW_DISTRICT = '/servicos/rede-de-atendimento-odonto/inicio/bairros',
	SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_LIST = '/servicos/rede-de-atendimento/locais-favoritos',
	SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_ADD = '/servicos/rede-de-atendimento/locais-favoritos/adicionar',
	SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_EDIT = '/servicos/rede-de-atendimento/locais-favoritos/editar',
}

enum ServicesEnum {
	SERVICES = '/servicos',
}

enum HealthCardEnum {
	HEALTH_CARD = '/carteirinha',
}

enum AppointmentEnum {
	APPOINTMENT = '/agendar',
}

enum HelpCenterEnum {
	HELP = '/servicos/ajuda',
	SEND_MESSAGE = '/servicos/mande-sua-mensagem',
	SERVICE_POINTS_ADDRESSES = '/servicos/nossos-enderecos',
}

enum PerksEnum {
	PERKS = '/beneficios',
}

enum ProfileEnum {
	PROFILE = '/meu-perfil',
	BENEFICIARY_SELECTION = '/meu-perfil/beneficiarios',
	CHANGE_PASSWORD = '/meu-perfil/alterar-senha',
	DATA_SHARING = '/meu-perfil/compartilhamento-de-dados',
	DATA_SHARING_FEATURES = '/meu-perfil/compartilhamento-de-dados/funcionalidades',
	FAVORITE_ADDRESSES_LIST = '/meu-perfil/enderecos-favoritos',
	FAVORITE_ADDRESSES_ADD = '/meu-perfil/enderecos-favoritos/adicionar',
	FAVORITE_ADDRESSES_EDIT = '/meu-perfil/enderecos-favoritos/editar',
}

enum FavoritesEnum {
	FAVORITE_DOCTORS = '/medicos-favoritos',
}

enum TelehealthBookingEnum {
	TELEHEALTH_BOOKING_INITIAL = '/agendar-teleconsulta/opcoes-iniciais',
	TELEHEALTH_BOOKING_CONTACT = '/agendar-teleconsulta/opcoes-iniciais/contato',
	TELEHEALTH_BOOKING_EMAIL = '/agendar-teleconsulta/opcoes-iniciais/email',
	TELEHEALTH_BOOKING_UF = '/agendar-teleconsulta/opcoes-iniciais/estado',
	TELEHEALTH_BOOKING_CITY = '/agendar-teleconsulta/opcoes-iniciais/cidade',
	TELEHEALTH_BOOKING_CONFIRMATION = '/agendar-teleconsulta/confirmacao/:id',
	TELEHEALTH_BOOKING_FLOW = '/agendar-teleconsulta',
}

enum EmergencyTelehealthEnum {
	EMERGENCY_TELEHEALTH_FLOW = '/pronto-atendimento-digital',
}

enum HealthBookingEnum {
	HEALTH_BOOKING_INITIAL = '/agendar-consulta/opcoes-iniciais',
	HEALTH_BOOKING_CONTACT = '/agendar-consulta/opcoes-iniciais/contato',
	HEALTH_BOOKING_EMAIL = '/agendar-consulta/opcoes-iniciais/email',
	HEALTH_BOOKING_UF = '/agendar-consulta/opcoes-iniciais/estado',
	HEALTH_BOOKING_CITY = '/agendar-consulta/opcoes-iniciais/cidade',
	HEALTH_BOOKING_CONFIRMATION = '/agendar-consulta/confirmacao/:id',
	HEALTH_BOOKING_FLOW = '/agendar-consulta',
	HEALTH_BOOKING_LOCALITY = '/agendar-consulta/opcoes-iniciais/regiao-cidade',
}

enum OdontoBookingEnum {
	ODONTO_BOOKING_INITIAL = '/agendar-dentista/opcoes-iniciais',
	ODONTO_BOOKING_CONTACT = '/agendar-dentista/opcoes-iniciais/contato',
	ODONTO_BOOKING_EMAIL = '/agendar-dentista/opcoes-iniciais/email',
	ODONTO_BOOKING_UF = '/agendar-dentista/opcoes-iniciais/estado',
	ODONTO_BOOKING_CITY = '/agendar-dentista/opcoes-iniciais/cidade',
	ODONTO_BOOKING_DISTRICT = '/agendar-dentista/opcoes-iniciais/bairro',
	ODONTO_BOOKING_CONFIRMATION = '/agendar-dentista/confirmacao/:id',
	ODONTO_BOOKING_FLOW = '/agendar-dentista',
}

enum ExamBookingEnum {
	EXAM_BOOKING_INITIAL = '/agendar-exame/opcoes-iniciais',
	EXAM_BOOKING_CONTACT = '/agendar-exame/opcoes-iniciais/contato',
	EXAM_BOOKING_EMAIL = '/agendar-exame/opcoes-iniciais/email',
	EXAM_BOOKING_UF = '/agendar-exame/opcoes-iniciais/estado',
	EXAM_BOOKING_CITY = '/agendar-exame/opcoes-iniciais/cidade',
	EXAM_BOOKING_CONFIRMATION = '/agendar-exame/confirmacao/:id',
	EXAM_BOOKING_FLOW = '/agendar-exame',
	EXAM_BOOKING_LOCALITY = '/agendar-exame/opcoes-iniciais/regiao-cidade',
	EXAM_BOOKING_PROCEDURE_SELECTION = '/agendar-exame/selecao-de-procedimento',
}

enum BookingAuthEnum {
	EXAM_AUTHORIZATION = '/agendamento/autorizacao-de-exame',
}

enum RequestSchedule {
	REQUEST = '/solicitar-agenda',
}

enum AuthorizationsEnum {
	AUTHORIZATIONS_ODONTO = '/servicos/autorizacoes-odonto',
	AUTHORIZATIONS = '/servicos/autorizacoes-saude',
	AUTHORIZATIONS_REQUESTS = '/servicos/autorizacoes-saude/solicitacoes',
	REQUEST_INITIAL_FLOW_UF = '/servicos/autorizacoes-saude/solicitar/estado',
	REQUEST_INITIAL_FLOW_CITY = '/servicos/autorizacoes-saude/solicitar/cidade',
	REQUEST_INITIAL_FLOW_CONTACT = '/servicos/autorizacoes-saude/solicitar/contato',
	REQUEST_INITIAL_FLOW_EMAIL = '/servicos/autorizacoes-saude/solicitar/email',
	REQUEST = '/servicos/autorizacoes-saude/solicitar',
	REQUEST_DETAIL = '/servicos/autorizacoes-saude/detalhe/:id',
	INSTRUCTIONS = '/servicos/autorizacoes-saude/instrucoes',
}

enum RefundEnum {
	REFUND = '/servicos/reembolso',
	REQUEST = '/servicos/reembolso/solicitar',
	REQUEST_PREVIEW = '/servicos/reembolso/solicitar-previa',
	CONSULT = '/servicos/reembolso/consultar',
	CONSULT_PREVIEW = '/servicos/reembolso/consultar-previa',
	SENDING_DOCUMENTS = '/servicos/reembolso/envio-de-documentos',
	TERMS_PREVIEW = '/servicos/reembolso/termos/solicitar-previa',
	TERMS_DEFAULT = '/servicos/reembolso/termos/:type',
	TERMS_ADDITIONAL_DOCS = '/servicos/reembolso/termos/envio-de-documentos',
	TERMS = '/servicos/reembolso/termos/solicitar',
}
enum FiveStarsRatingEnum {
	FIVESTARS_RATING = '/avaliacao',
}

enum OperationalCostEnum {
	OPERATIONAL_COST = '/custo-operacional',
	OPERATIONAL_COST_NEED_PASSWORD = '/custo-operacional/autorizacao-necessaria',
}

enum FinancialPendencyEnum {
	FINANCIAL_PENDENCY = '/inadimplencia',
}

enum FranchisesTableEnum {
	FRANCHISES_TABLE = '/servicos/tabela-de-franquias',
}

enum TokenEnum {
	TOKEN = '/token',
}

enum ConsultProtocolsEnum {
	CONSULT_PROTOCOLS = '/servicos/consulta-de-protocolos',
}

enum ContractAdaptationEnum {
	CONTRACT_ADAPTATION = '/servicos/adaptacao-de-contratos',
}

enum ContractReactivationEnum {
	CONTRACT_REACTIVATION = '/servicos/reativacao-de-contratos',
}

enum ChangePlanEnum {
	CHANGE_PLAN = '/servicos/alterar-plano',
	CHANGE_PLAN_HISTORY = '/servicos/alterar-plano/historico',
	CHANGE_PLAN_NEW_PLAN = '/servicos/alterar-plano/escolher-novo-plano',
	CHANGE_PLAN_NEW_PLAN_UF = '/servicos/alterar-plano/escolher-novo-plano/estado',
	CHANGE_PLAN_NEW_PLAN_CITY = '/servicos/alterar-plano/escolher-novo-plano/cidade',
}

enum CancelledContractEnum {
	FIND_OUT_MORE = '/contrato-cancelado/saiba-mais',
}

enum CommunicationsEnum {
	COMMUNICATIONS = '/comunicados',
}

enum BusinessPermissionFlowEnum {
	ACCESS_PERMISSION = '/permissao-de-acesso',
}

enum MyHospitalizationFlowEnum {
	HOME = '/servicos/minha-internacao',
	GENERAL_ORIENTATIONS = '/servicos/minha-internacao/orientacoes-gerais',
	INFORMATION = '/servicos/minha-internacao/informacoes',
	OPINIONS = '/servicos/minha-internacao/pareceres',
	PATIENT_DATA = '/servicos/minha-internacao/dados-do-paciente',
	EXAMS = '/servicos/minha-internacao/exames',
	REQUESTED_EXAMS = '/servicos/minha-internacao/exames/solicitados',
	DOCTOR_VISITS = '/servicos/minha-internacao/visitas-medicas',
	PROCEDURES = '/servicos/minha-internacao/procedimentos',
	PRESCRIPTIONS = '/servicos/minha-internacao/prescricoes',
}

enum MyReferralsEnum {
	MY_REFERRALS = '/servicos/meus-encaminhamentos',
	MY_REFERRALS_HISTORY = '/servicos/meus-encaminhamentos/historico',
}

enum FacialBiometricEnum {
	FACIAL_BIOMETRIC = '/biometria-facial',
	FACE_PHOTO = '/biometria-facial/fotos-do-rosto',
	DOCUMENT_PHOTO = '/biometria-facial/fotos-do-documento',
	SUCCESS = '/biometria-facial/sucesso',
}

enum NotificationsEnum {
	NOTIFICATIONS = '/notificacoes',
}

export {
	AppointmentEnum,
	AuthorizationsEnum,
	BookingAuthEnum,
	ExamBookingEnum,
	ExamResultsEnum,
	FavoritesEnum,
	FinancialPendencyEnum,
	FirstAccessEnum,
	FiveStarsRatingEnum,
	ForgotPasswordEnum,
	GuidesEnum,
	HealthBookingEnum,
	HealthCardEnum,
	HelpCenterEnum,
	HomeEnum,
	MyAppointmentsEnum,
	MyPaymentsEnum,
	OdontoBookingEnum,
	OperationalCostEnum,
	PerksEnum,
	ProfileEnum,
	RefundEnum,
	SelectionFlowEnum,
	ServicesEnum,
	SignInEnum,
	SignUpEnum,
	FranchisesTableEnum,
	TokenEnum,
	TelehealthBookingEnum,
	ConsultProtocolsEnum,
	ContractAdaptationEnum,
	ContractReactivationEnum,
	ChangePlanEnum,
	CancelledContractEnum,
	CommunicationsEnum,
	BusinessPermissionFlowEnum,
	AuthorizationB2BEnum,
	RequestSchedule,
	MyHospitalizationFlowEnum,
	EmergencyTelehealthEnum,
	MyReferralsEnum,
	FacialBiometricEnum,
	NotificationsEnum,
};
